import { useState } from "react";
import MantineImage from "../../components/mantine/image";
import { PasswordInput, Button, Container, Paper, Group, Center, Text, Box } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import Logo from "../../assets/images/jb-logo.svg";
import RightImage from "../../assets/images/login-right-bg.svg";
import RightArrow from "../../assets/images/login-arw.svg";
import LockIcon from "../../assets/images/password-ico.svg";

interface iForm {
  handleChange?: any;
  submit: any;
  formData: any;
}

const Form = ({ formData, submit }: iForm) => {
  const navigate = useNavigate(); 
  

  return (
    <Container fluid className="overflow-hidden flex h-screen p-0 item-center justify-between bg-[#041E42] w-full">
      <Group className="relative h-full flex-col max-w-[435px] w-full justify-center">
        <Paper className="bg-transparent w-full">
          <Center mb="2rem">
            <MantineImage src={Logo} className="max-w-[130px] w-full" />
          </Center>
          <form onSubmit={submit}>
            <Group
              mb="lg"
              className="bg-[#2F7FE2] flex-col rounded-tr-[46px] rounded-br-[46px] p-8 flex-1 w-full item-start"
            >

              <PasswordInput
                {...formData?.getInputProps("password")}
                label={<span>New Password <span style={{ color: 'red' }}>*</span></span>}
                placeholder="xxxxxxxxxxxxxx"
                leftSection={<MantineImage src={LockIcon} width={18} className="mx-2" />}             
                w={"100%"}
                styles={{
                  label: { color: 'white', marginBottom: '0.5rem', fontSize: '13px', lineHeight: '16px', fontFamily: 'Gantari-Bold' },
                  input: { backgroundColor: 'white', padding: '10px', paddingLeft: 34, height: 46, width: '100%', maxWidth: '370px' },
                }}               
                mb="sm"
                className="custom-placeholder"
                value={formData.values.password}
                onChange={(event: any) =>
                  formData.setFieldValue("password", event.currentTarget?.value)
                }
                error={formData.errors.password}
              />

              <PasswordInput
                {...formData?.getInputProps("confirmPassword")}
                label={<span>Confirm Password <span style={{ color: 'red' }}>*</span></span>}
                placeholder="xxxxxxxxxxxxxx"
                leftSection={<MantineImage src={LockIcon} width={18} className="mx-2" />}
                w={"100%"}
                styles={{
                  label: { color: 'white', marginBottom: '0.5rem', fontSize: '13px', lineHeight: '16px', fontFamily: 'Gantari-Bold' },
                  input: { backgroundColor: 'white', padding: '10px', paddingLeft: 34, height: 46, width: '100%', maxWidth: '370px' },
                }}                
                mb="sm"
                className="custom-placeholder"
                value={formData.values.confirmPassword}
                onChange={(event: any) =>
                  formData.setFieldValue("confirmPassword", event.currentTarget?.value)
                }
                error={formData.errors.confirmPassword}
                
              />
              
              <Text
               className="text-white text-sm cursor-pointer underline"
                onClick={() => navigate('/')}
              >
                Back to Login
              </Text>
            </Group>
            <Group>
              <Button
                fullWidth
                size="md"
                style={{ backgroundColor: '#FF5C39', color: 'white', borderRadius: '0px 16px 16px 0px', height: 54, fontSize: '1.125rem' }}              
                type="submit"
              >
                Send
                <MantineImage src={RightArrow} style={{ marginLeft: "20px", width: "40px" }} />
              </Button>
            </Group>
          </form>
        </Paper>
        <Text className="text-xs text-white absolute bottom-2 left-0 text-center w-full">
          © 2026 JB360
        </Text>
      </Group>
      <Group className="sm-hidden mr-[20px]">
        <Box maw={227} mx="auto" className="pt-[100px]">
          <div
            className="curve-custom"
            style={{ backgroundImage: `url(${RightImage})` }}
          />
        </Box>
      </Group>
    </Container>
  );
};

export default Form;
